import * as React from "react";

const SvgIcnUnorderedList = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
        <path
            d="M3 5.25a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zM3 10a1.25 1.25 0 102.5 0A1.25 1.25 0 003 10zM3 14.75a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.374 5.25c0-.345.28-.625.625-.625h8.376a.625.625 0 110 1.25H7.999a.625.625 0 01-.625-.625zM7.374 10c0-.345.28-.625.625-.625h8.376a.625.625 0 110 1.25H7.999A.625.625 0 017.374 10zM7.374 14.75c0-.345.28-.625.625-.625h8.376a.625.625 0 110 1.25H7.999a.625.625 0 01-.625-.625z"
            fill="currentColor"
        />
    </svg>
);

export default SvgIcnUnorderedList;
